/**
 * Default badge colours for built-in roles.
 * Keyed by role key (e.g., 'TENANT_ADMIN').
 * Used by components that need to assign a colour to a role
 * when no explicit colour is provided.
 */
export const ROLE_COLORS: Record<string, string> = {
  CARRIER: '#D22D64',
  DRIVER: '#2E8AB8',
  SITE_MANAGER: '#29A37A',
  SITE_OPERATOR: '#E6801A',
  SPACE_ADMIN: '#6B33CC',
  TENANT_ADMIN: '#2662D9',
};

/** Fallback colour for roles not in the ROLE_COLORS map. */
export const DEFAULT_ROLE_COLOR = '#6B7280';
